import React from 'react';
import { ForOwners } from '@yme/organisms/for-owners';
import { TabletCards } from './TabletCards';
import { getDataForTabletView } from './helpers';
export function MobileCard({ cards, isRightToLeft }) {
    const changedCards = getDataForTabletView(cards);
    return changedCards.length > 1 ? (React.createElement(ForOwners, { isRightToLeft: isRightToLeft, data: changedCards })) : (React.createElement(TabletCards, { cards: cards, isRightToLeft: isRightToLeft }));
}
